<template>
    
  <div>

    <page-padding>
      <spinner v-if="showLoader"/>
      <div v-if="!showLoader && !hasDocuments">{{$t('language.no_documents')}}</div>
    </page-padding>

   <infinite-list v-if="hasDocuments" :list="documents[download_id+'documents']">

        <template v-slot:default="document">
          <button-document :download_id="download_id" :item="document.item"></button-document>
         
      </template>
    </infinite-list>


  </div>
</template>

<script>

import { mapState } from 'vuex';
import PagePadding from '../../components/PagePadding';
import InfiniteList from '../../components/InfiniteList.vue';
import ButtonDocument from './ButtonDocument.vue';
import Spinner from '../../components/Spinner';
import { eventBus } from '../../services/EventBus.js';

export default {
  name: 'list-documents',
  props:{
    download_id:{default:0},
  },
  data:function(){
    return {
      showLoader:false,
    }
  },
  components:{
    PagePadding,
    InfiniteList,
    ButtonDocument,
    Spinner,
  },
  methods:{
     emitLoadStart(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_START_LOAD')
        vm=vm.$parent;
      }
    },
    emitLoadEnd(){
      // emit to all parent who want to hear..
      let vm=this.$parent;
      while(vm){
        vm.$emit('SCROLLPAGE_END_LOAD')
        vm=vm.$parent;
      }
    },
    load_documents(){
     this.emitLoadStart();

      this.$store.dispatch('get_documents',{store_key:this.download_id+"documents", id:this.download_id}).then(()=>{
        this.emitLoadEnd();
      })
    }
  },
  computed:{
    ...mapState([
       'documents',
       ]),
       hasDocuments:function(){
         if(this.documents[this.download_id+"documents"]){
           return this.documents[this.download_id+"documents"] ? this.documents[this.download_id+"documents"].length : false;
         }else{
           return false;
         }
       }
  },
  beforeDestroy(){
   
      eventBus.$off("RELOAD_FROM_PULL",this.load_documents)
    },
  created:function(){
    eventBus.$on("RELOAD_FROM_PULL",this.load_documents)
    this.load_documents();
    
  },  
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>

